import React from 'react';

import { PresetStorage } from '@gogame/screens';

import { mapStateToPreset, mapPresetToState } from 'scenes/KPI/schemas';

const TrackerPresetStorage = (props) => (
  <PresetStorage
    mapScreenStateToPreset={mapStateToPreset}
    mapPresetToScreenState={(data, parentData) => {
      const normalizedData = mapPresetToState(data);

      if (!parentData) {
        return normalizedData;
      }

      return {
        ...normalizedData,
        period: parentData.period,
      };
    }}
    {...props}
  />
);

export default TrackerPresetStorage;
